module.exports = __webpack_public_path__ + "img/15-3.793786f6.png";